//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { IFRAMES } from '@/js/constants';
export default {
  name: 'ContDlpDashboard',
  data: function data() {
    return {
      srcEmbebed: IFRAMES['ContDlpDashboard']
    };
  }
};